var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path0, _g2, _g3, _g4, _path1, _g5, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g6, _g7, _path18, _path19, _path20, _path21, _g8, _path22, _g9, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg2Scam = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2-scam_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5B5B5B",
    stroke: "#B7B7B7",
    strokeWidth: 0.067,
    d: "M56.406 21.608 79.47 36.789s.742 1.187 1.154 1.875c.41.688.338 1.251-.278 1.997l-46.18 55.925c-.63.761-1.143 1.166-1.912.971s-2.32-.821-2.32-.821L10.613 77.063z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B5B5B",
    stroke: "#B7B7B7",
    strokeWidth: 0.067,
    d: "M53.68 22.151a2.26 2.26 0 0 1 2.982-.45L79.06 36.418a1.694 1.694 0 0 1 .376 2.495L32.04 96.31a1.694 1.694 0 0 1-2.517.107l-18.75-19.13a2.26 2.26 0 0 1-.129-3.02z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#B7B7B7",
    strokeWidth: 0.067,
    d: "M53.664 22.424a2.26 2.26 0 0 1 2.989-.445l22.193 14.694c.67.445.81 1.373.296 1.993l-47.15 57.099a1.694 1.694 0 0 1-2.512.11L11.06 77.204a2.26 2.26 0 0 1-.133-3.025z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M53.827 22.53a2.03 2.03 0 0 1 2.686-.404l22.12 14.646c.558.369.672 1.14.245 1.658L31.8 95.44a1.58 1.58 0 0 1-2.34.108L11.325 77.18a2.256 2.256 0 0 1-.13-3.021z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "2-scam_svg__b",
    width: 70,
    height: 76,
    x: 10,
    y: 21,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M53.827 22.526a2.03 2.03 0 0 1 2.686-.404l22.12 14.646c.558.369.672 1.14.245 1.658L31.8 95.436a1.58 1.58 0 0 1-2.34.108L11.325 77.177a2.256 2.256 0 0 1-.13-3.022z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#2-scam_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2-scam_svg__c",
    width: 58,
    height: 64,
    x: 41,
    y: 18,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M98.873 61.625 43.799 81.576c3.83-9.237 1.94-17.6-1.897-25.618l1.596-37.74z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#2-scam_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#2-scam_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE0BA",
    d: "M73.926 46c-.158 1.759-4.048 2.487-8.623 1.95s-7.808-2.647-7.683-4.072c.175-1.995 3.781-2.541 8.179-1.968 5.06.659 8.287 2.312 8.127 4.09"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A65B00",
    strokeWidth: 0.033,
    d: "M73.422 44.714c.358.413.527.846.487 1.285-.039.433-.308.804-.764 1.11-.456.305-1.097.544-1.878.71-1.561.335-3.676.383-5.962.114-2.285-.268-4.235-.93-5.598-1.7-.68-.386-1.215-.799-1.57-1.204-.356-.405-.531-.8-.5-1.15.086-.984 1.02-1.618 2.493-1.932 1.47-.313 3.47-.308 5.667-.021 2.528.33 4.599.907 6.016 1.624.708.358 1.252.751 1.61 1.164Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#A65B00",
    d: "M72.734 45.226c-.065 1.212-3.313 1.52-7.159 1.07-3.845-.452-6.751-1.955-6.637-2.932.135-1.148 3.1-1.675 6.946-1.224 3.43.403 6.911 1.924 6.85 3.086"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC47",
    d: "M72.658 45.379c-.052 1.11-3.266 1.364-7.077.917s-6.701-1.85-6.596-2.744c.123-1.05 3.054-1.507 6.865-1.06 3.399.399 6.86 1.824 6.808 2.887"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "2-scam_svg__e",
    width: 15,
    height: 5,
    x: 58,
    y: 42,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    d: "M72.659 45.38c-.053 1.11-3.267 1.364-7.077.917s-6.702-1.85-6.597-2.744c.123-1.05 3.054-1.507 6.865-1.06 3.4.399 6.86 1.824 6.809 2.887"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2-scam_svg__f)",
    mask: "url(#2-scam_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68.946 45.522c.918-.042.801-.377.336-.8l1.342-.006-.432-.327-1.307.007-.353-.261 1.315-.006-.432-.327-1.341.006-.282-.208h.004l-.595-.45-.872.004s.33.241.314.237c.175.133.04.177-.11.19l-1.528.007q.02.015.04.035l-.046-.035-2.141.01c-.112-.005-.31-.029-.433-.121a9 9 0 0 1-.314-.237l-1.06-.06.561.424.304.234-1.357.006.432.327 1.342-.007q.171.135.339.261l-1.337.007.432.326 1.355-.006c.805.549 1.659.931 3.011.973 1.09.034 1.294-.164 1.07-.477a4.3 4.3 0 0 0 1.743.274m-3.505-.443c-1.014.005-1.817-.69-2.11-.912l1.798-.008c.292.221 1.37.915.312.92m2.335-.164c-.922.004-1.58-.576-1.824-.76l1.63-.008c.244.184 1.157.763.194.768"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#2-scam_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE0BA",
    d: "M55.585 68.845c-.138 6.429-6.942 10.414-14.902 10.046s-13.897-6.777-13.656-11.988c.284-6.126 6.35-10.456 14.31-10.088 7.1.328 14.38 5.873 14.247 12.03"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#A65B00",
    strokeWidth: 0.058,
    d: "M51.154 60.667c2.687 2.193 4.467 5.111 4.402 8.178-.069 3.203-1.798 5.798-4.504 7.548-2.708 1.75-6.392 2.653-10.367 2.469a15.56 15.56 0 0 1-9.885-4.17c-2.445-2.295-3.864-5.193-3.744-7.788.282-6.103 6.329-10.429 14.28-10.06 3.543.163 7.132 1.63 9.818 3.823Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC47",
    fillRule: "evenodd",
    d: "M41.42 58.406c6.085.282 12.34 4.718 12.245 9.622-.1 5.11-5.896 8.262-12.7 7.962-5.369-.267-9.682-3.515-11.26-6.969-.374-.881-.56-1.77-.52-2.62.225-4.878 5.412-8.31 12.235-7.995",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A65B00",
    fillRule: "evenodd",
    d: "M41.544 57.692c6.201.287 12.571 4.898 12.469 10.002-.108 5.328-6.042 8.617-12.995 8.295l-.015-.002c6.79.289 12.567-2.86 12.666-7.962.096-4.904-6.159-9.341-12.244-9.622-6.823-.316-12.01 3.117-12.236 7.995-.04.846.145 1.732.516 2.61-.456-1-.683-2.017-.638-2.984.235-5.077 5.524-8.654 12.477-8.332",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.513 71.589c1.876-.31 1.789-1.751 1.036-3.521l2.717-.214-.728-1.36-2.646.209a64 64 0 0 0-.599-1.085l2.664-.21-.728-1.358-2.717.213a51 51 0 0 1-.478-.864h.009l-1.004-1.876-1.766.14s.56 1.002.53.987c.294.55.001.76-.307.84l-3.096.243c.02.038.045.088.066.145l-.077-.144-4.338.341c-.223-.007-.614-.083-.821-.467-.01.019-.53-.989-.53-.989l-2.12-.114.948 1.77c.176.328.343.653.51.971l-2.747.218.727 1.358 2.72-.215q.285.56.568 1.088l-2.707.212.729 1.36 2.743-.216c1.384 2.273 2.941 3.818 5.66 3.811 2.188-.005 2.691-.892 2.375-2.22.91.75 2.035 1.175 3.407.947m-6.896-1.44c-2.053.163-3.368-2.746-3.862-3.668l3.641-.286c.494.922 2.364 3.786.221 3.954m4.8-1.037c-1.87.147-2.943-2.281-3.354-3.048l3.303-.26c.411.767 2 3.154.05 3.308"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#2-scam_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE0BA",
    d: "M60.058 56.476c-1.627 3.318-6.138 3.75-10.199 1.633-4.06-2.117-5.606-6.894-4.22-9.553 1.63-3.125 5.84-3.915 9.901-1.798 3.622 1.889 6.076 6.54 4.518 9.718"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#A65B00",
    strokeWidth: 0.058,
    d: "M59.715 51.146c.87 1.792 1.09 3.739.317 5.317-.809 1.649-2.333 2.582-4.164 2.84-1.832.256-3.97-.163-5.996-1.22a8.93 8.93 0 0 1-4.138-4.559c-.719-1.786-.757-3.635-.07-4.955 1.62-3.105 5.81-3.899 9.863-1.786 1.805.942 3.32 2.572 4.188 4.363Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC47",
    fillRule: "evenodd",
    d: "M55.198 47.607c3.104 1.619 5.291 5.444 4.056 7.978-1.287 2.637-5.065 2.88-8.537 1.082-2.743-1.438-4.21-4.181-4.194-6.367.02-.547.137-1.053.362-1.485 1.297-2.488 4.833-3.023 8.313-1.208",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A65B00",
    fillRule: "evenodd",
    d: "M55.435 47.265c3.164 1.65 5.37 5.594 4.081 8.23-1.31 2.68-5.031 3.015-8.5 1.322 3.388 1.634 6.99 1.331 8.24-1.23 1.237-2.534-.95-6.36-4.055-7.98-3.48-1.814-7.015-1.28-8.312 1.21-.224.428-.342.93-.362 1.472.006-.627.133-1.207.388-1.697 1.35-2.59 4.974-3.176 8.52-1.327",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.186 55.954c1.053.293 1.356-.48 1.391-1.585l1.469.546-.05-.885-1.43-.531a37 37 0 0 0-.05-.71l1.439.535-.051-.885-1.468-.546q-.024-.29-.04-.566l.005.002-.07-1.22-.955-.355s.05.658.038.643c.02.358-.184.397-.363.363l-1.673-.622a1 1 0 0 1 0 .092q-.004-.045-.006-.094l-2.344-.871c-.115-.058-.3-.192-.315-.443-.01.008-.037-.643-.037-.643l-1.078-.573.066 1.152q.016.321.031.63l-1.485-.551.05.884 1.47.546q.014.36.034.704l-1.463-.543.051.885 1.483.55c.171 1.52.61 2.703 2.028 3.356 1.142.527 1.62.186 1.776-.582.293.611.776 1.104 1.547 1.317m-3.247-2.418c-1.11-.412-1.092-2.247-1.126-2.847l1.967.732c.035.6.317 2.545-.841 2.115m2.753.62c-1.01-.375-.982-1.9-1.01-2.4l1.784.663c.029.5.279 2.128-.774 1.737"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "2-scam_svg__i",
    width: 49,
    height: 64,
    x: -2,
    y: 18,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "m-1.537 78.309 45.336 3.268c3.83-9.237 2.842-17.079-.994-25.098L31.276 18.896z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#2-scam_svg__i)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#2-scam_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE0BA",
    d: "M55.585 68.847c-.138 6.429-6.942 10.414-14.901 10.046-7.96-.368-13.897-6.777-13.656-11.988.283-6.126 6.35-10.456 14.31-10.088 7.1.328 14.379 5.873 14.247 12.03"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#A65B00",
    strokeWidth: 0.058,
    d: "M51.155 60.669c2.687 2.193 4.467 5.111 4.401 8.178-.069 3.203-1.797 5.798-4.504 7.548s-6.392 2.653-10.367 2.469a15.56 15.56 0 0 1-9.885-4.17c-2.445-2.295-3.864-5.193-3.744-7.788.283-6.103 6.33-10.429 14.28-10.06 3.544.163 7.133 1.63 9.819 3.823Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC47",
    fillRule: "evenodd",
    d: "M41.42 58.407c6.085.282 12.34 4.72 12.244 9.623-.1 5.105-5.885 8.256-12.682 7.962-5.386-.261-9.713-3.523-11.286-6.988-.368-.875-.55-1.757-.512-2.6.226-4.879 5.413-8.312 12.236-7.997",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A65B00",
    fillRule: "evenodd",
    d: "M41.544 57.694c6.202.287 12.571 4.898 12.47 10.001-.108 5.329-6.043 8.619-12.996 8.297q-.024-.001-.048-.004c6.804.3 12.6-2.852 12.7-7.961.094-4.904-6.16-9.34-12.245-9.622-6.823-.315-12.01 3.117-12.236 7.995-.039.85.147 1.738.52 2.619-.458-1.003-.687-2.022-.642-2.992.235-5.077 5.525-8.655 12.477-8.333",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.513 71.59c1.876-.309 1.789-1.75 1.036-3.52l2.717-.214-.728-1.36-2.646.209a64 64 0 0 0-.599-1.085l2.664-.21-.728-1.358-2.717.213a51 51 0 0 1-.478-.864h.009l-1.004-1.876-1.766.14s.56 1.002.53.986c.294.551.001.761-.307.84l-3.096.244c.02.038.045.087.066.144l-.077-.143-4.338.341c-.223-.007-.614-.083-.821-.468-.01.02-.53-.988-.53-.988l-2.12-.115.948 1.77c.176.33.343.654.51.972l-2.747.217.727 1.358 2.72-.214q.285.56.568 1.087l-2.707.213.729 1.36 2.743-.216c1.384 2.273 2.941 3.818 5.66 3.81 2.188-.004 2.691-.891 2.375-2.219.91.75 2.035 1.175 3.407.946m-6.896-1.439c-2.053.163-3.368-2.747-3.862-3.668l3.641-.287c.494.922 2.364 3.786.221 3.955m4.8-1.037c-1.87.147-2.943-2.281-3.354-3.049l3.303-.26c.411.768 2 3.155.05 3.309"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.404,
    cy: 57.98,
    fill: "#000",
    fillOpacity: 0.2,
    rx: 11.944,
    ry: 8.259,
    transform: "rotate(-31.91 30.404 57.98)"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F6F6F",
    d: "M27.093 82.227a.17.17 0 0 1 .003-.249l.44-.4c.332-.3.591-.655.77-1.05a3 3 0 0 0 .03-2.417 3.2 3.2 0 0 0-.743-1.073 3.5 3.5 0 0 0-1.13-.722 3.7 3.7 0 0 0-1.293-.254 3.7 3.7 0 0 0-1.299.217c-.429.155-.815.387-1.148.689a.2.2 0 0 1-.267-.004.17.17 0 0 1 .004-.249 3.8 3.8 0 0 1 1.274-.764c.46-.167.944-.248 1.44-.24.497.006.98.101 1.435.28a3.8 3.8 0 0 1 1.254.802c.36.345.638.746.825 1.19a3.35 3.35 0 0 1-.034 2.682c-.198.44-.486.832-.855 1.167l-.44.399a.2.2 0 0 1-.266-.004"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F6F6F",
    d: "M26.083 83.025c-.01-.036-.249-.89.924-1.953.513-.466.8-1.091.809-1.76a2.4 2.4 0 0 0-.764-1.783 2.77 2.77 0 0 0-1.89-.76 2.77 2.77 0 0 0-1.909.706c-.26.236-.586.323-.942.25a1.4 1.4 0 0 1-.449-.178l.219-.286h-.001c.001 0 .137.088.322.123q.338.065.587-.162c.296-.268.64-.475 1.022-.613a3.2 3.2 0 0 1 1.155-.193 3.3 3.3 0 0 1 1.15.226c.378.15.717.365 1.006.642.288.277.51.598.66.955a2.68 2.68 0 0 1-.027 2.15 2.8 2.8 0 0 1-.685.935c-.296.269-.663.678-.792 1.155-.076.28-.031.452-.03.454l-.001-.002z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F6F6F",
    d: "M20.76 80.144a.17.17 0 0 1-.033-.204.195.195 0 0 1 .254-.075c.009.004.874.418 1.927.642.61.13 1.162.172 1.64.124.58-.058 1.054-.25 1.405-.568a1.05 1.05 0 0 0 .02-1.556 1.24 1.24 0 0 0-1.668-.024 2.24 2.24 0 0 1-1.03.531c-.31.07-.648.083-1.005.039a3.8 3.8 0 0 1-1.063-.292.17.17 0 0 1-.084-.237.195.195 0 0 1 .254-.077c.004.002.415.194.952.258q.465.055.862-.035.488-.11.85-.44a1.64 1.64 0 0 1 2.202.032c.6.575.588 1.496-.026 2.053-.414.376-.963.6-1.631.666-.521.052-1.116.007-1.768-.132a10 10 0 0 1-2.01-.671.2.2 0 0 1-.048-.034"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F6F6F",
    d: "M20.907 79.43a.17.17 0 0 1-.036-.198.194.194 0 0 1 .25-.085c.008.004.834.359 1.788.58.848.197 1.973.327 2.519-.169a.38.38 0 0 0 .007-.562.45.45 0 0 0-.603-.008.2.2 0 0 1-.267-.004.17.17 0 0 1 .003-.249.846.846 0 0 1 1.137.016.715.715 0 0 1-.014 1.06c-.317.288-.75.424-1.328.442-.44.013-.962-.05-1.549-.186a12 12 0 0 1-1.85-.6.2.2 0 0 1-.057-.038M21.17 81.255a.17.17 0 0 1-.038-.192.194.194 0 0 1 .248-.092 6.062 6.062 0 0 0 2.953.395.2.2 0 0 1 .17.063c.04.047.053.11.032.168-.18.5-.198 1.057-.048 1.568.028.093-.031.19-.132.215-.1.026-.204-.03-.232-.123a2.9 2.9 0 0 1-.025-1.515 6.5 6.5 0 0 1-2.867-.448.2.2 0 0 1-.06-.039"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F6F6F",
    d: "M25.234 83.375a.2.2 0 0 1-.032-.042c-.017-.03-.16-.305-.063-.79q.085-.413.367-.86c.23-.362.557-.738.974-1.116.37-.335.576-.785.582-1.266a1.74 1.74 0 0 0-.55-1.283 2 2 0 0 0-1.36-.547 2 2 0 0 0-1.373.508c-.37.335-.866.47-1.45.402a2.9 2.9 0 0 1-.764-.199c-.094-.042-.134-.147-.089-.234a.194.194 0 0 1 .251-.083c.007.003.291.127.657.167.47.053.85-.05 1.131-.306a2.38 2.38 0 0 1 1.642-.607 2.4 2.4 0 0 1 1.625.654c.431.413.665.958.658 1.533a2.07 2.07 0 0 1-.696 1.514c-.882.8-1.158 1.415-1.234 1.79-.073.362.025.559.026.56a.17.17 0 0 1-.079.238.2.2 0 0 1-.223-.034M21.542 82.13c.032-.105.154-.16.262-.121.149.054.344.122.465.153.196.05.51.098.887.044a.2.2 0 0 1 .16.047.17.17 0 0 1 .057.146c0 .002-.028.282.066.513.037.09-.012.192-.11.227a.194.194 0 0 1-.243-.103 1.4 1.4 0 0 1-.093-.46c-.538.034-1.07-.127-1.332-.223a.183.183 0 0 1-.119-.224"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E008F",
    d: "m44.914-2.917-.293-1.339c-3.501.691-4.665 6.231-4.555 8.292l1.68-.332c0-1.92 1.115-6.59 3.168-6.621"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#230AFF",
    d: "m45.26-2.916-.293-1.339c-3.501.691-4.847 6.276-4.738 8.337l1.68-.332c0-1.92 1.298-6.636 3.351-6.666"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "2-scam_svg__k",
    width: 45,
    height: 49,
    x: 24,
    y: 17,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC47",
    d: "M24.097 58.12c-.203-1.786 2.693-8.342 7.028-15.73 4.236-7.22 8.447-12.853 10.185-13.756C60.04-5.792 72.269 53.67 67.934 61.06c-4.236 7.22-32.122 5.168-43.837-2.939"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#2-scam_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M41.479 13.187c.453.207.897.254 1.302.149.71-.185 1.298-.84 1.595-1.919.595-2.158-.198-5.201-1.77-6.795-.786-.797-1.619-1.082-2.328-.897-.71.185-1.298.84-1.596 1.919-.474 1.72-.067 4 .913 5.663l-2.082 7.463c-1.897-1.549-3.838-2.066-5.529-1.625-1.966.512-3.592 2.32-4.414 5.306-1.65 5.988.563 14.43 4.931 18.86 2.19 2.22 4.508 3.013 6.484 2.498 1.966-.512 3.593-2.32 4.415-5.306l.539-1.956-5.364-.29 2.187 2.218c-.67 1.166-1.576 1.899-2.604 2.166-1.506.393-3.275-.212-4.947-1.908-3.338-3.384-5.019-9.823-3.764-14.378.626-2.273 1.865-3.652 3.365-4.042 1.506-.392 3.274.212 4.947 1.908l.935.948zm1.458-3.229c-.147.534-.438.857-.789.949s-.763-.05-1.151-.443c-.778-.789-1.17-2.293-.876-3.361.147-.534.438-.857.79-.949.35-.091.762.05 1.15.444.778.788 1.17 2.293.876 3.36",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m41.28 22.495 2.786-9.983-2.587.674-2.785 9.983zM42.182 10.632 40.1 18.096l-2.587.674 2.082-7.464zM45.987 37.83l.538-1.957-2.587.674-.538 1.956z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m40.346 21.547.935.948-2.587.674-.935-.948zM46.526 35.873l-5.364-.29-2.587.674 5.364.29zM41.572 43.136c1.966-.513 3.592-2.32 4.415-5.306l-2.587.673c-.823 2.986-2.449 4.794-4.415 5.307zM40.1 18.097c-1.897-1.55-3.838-2.066-5.529-1.626l-2.585.674c1.69-.44 3.63.077 5.527 1.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.162 35.583 43.35 37.8l-2.587.674-2.187-2.217zM35.399 19.638c1.506-.392 3.274.213 4.947 1.909l-2.587.674c-1.673-1.696-3.441-2.3-4.947-1.909z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M43.349 37.8c-.67 1.167-1.576 1.9-2.605 2.167l-2.586.674c1.028-.268 1.934-1 2.603-2.167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40.745 39.967c-1.506.392-3.275-.212-4.947-1.908l-2.587.674c1.672 1.696 3.44 2.3 4.947 1.908zM32.034 23.68c.626-2.272 1.865-3.65 3.364-4.041l-2.586.673c-1.5.39-2.74 1.77-3.365 4.042zM35.088 40.636c2.19 2.22 4.507 3.013 6.483 2.499l-2.586.674c-1.976.515-4.294-.279-6.484-2.5zM34.571 16.471c-1.965.512-3.592 2.32-4.414 5.306l-2.587.674c.822-2.986 2.449-4.794 4.414-5.306z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.798 38.059c-3.338-3.385-5.019-9.824-3.764-14.38l-2.587.675c-1.255 4.555.426 10.994 3.764 14.379z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30.156 21.777c-1.649 5.987.564 14.43 4.932 18.86l-2.587.673c-4.368-4.43-6.58-12.872-4.932-18.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M45.174 4.023c1.572 1.594 2.365 4.637 1.77 6.796-.467 1.694-1.65 2.338-2.897 1.766l-2.785 9.984-.935-.947c-3.338-3.385-7.057-2.422-8.312 2.133s.426 10.994 3.764 14.379c2.815 2.853 5.9 2.617 7.55-.259l-2.185-2.216 5.363.29-.538 1.955c-1.65 5.987-6.531 7.237-10.9 2.807-4.368-4.429-6.58-12.872-4.931-18.86 1.53-5.553 5.84-7.03 9.943-3.68l2.083-7.466c-.98-1.663-1.387-3.94-.914-5.66.595-2.159 2.352-2.616 3.924-1.022m-.544 1.975c-.778-.788-1.646-.562-1.94.506-.294 1.067.098 2.572.875 3.36.778.788 1.646.562 1.94-.505s-.098-2.572-.875-3.36"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#2-scam_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE0BA",
    d: "M41.064 29.182c2.996 1.758-.224 9.192-5.119 17.536-4.895 8.343-9.85 14.638-12.755 12.933-2.392-1.403.908-8.668 5.803-17.012 4.895-8.343 9.791-14.794 12.071-13.457"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A65B00",
    strokeWidth: 0.097,
    d: "M29.035 42.664c2.447-4.17 4.893-7.867 7.01-10.352 1.06-1.243 2.036-2.18 2.886-2.723.852-.545 1.564-.685 2.109-.365.73.428 1.086 1.204 1.128 2.269.043 1.065-.23 2.413-.75 3.971-1.041 3.117-3.068 7.058-5.515 11.23-2.447 4.17-4.907 7.826-7.117 10.225-1.106 1.2-2.145 2.083-3.087 2.56-.941.476-1.777.544-2.485.13-.574-.337-.815-1.03-.766-2.033.05-1 .388-2.295.957-3.811 1.136-3.03 3.183-6.93 5.63-11.1Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC47",
    d: "M29.92 43.014c3.627-6.183 7.233-11.005 8.725-11.785.169 1.537-2.309 7.15-6.02 13.478-3.63 6.185-7.237 11.01-8.727 11.785-.17-1.534 2.309-7.15 6.022-13.478"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#A65B00",
    d: "M29.224 42.713c4.165-7.1 8.302-12.407 9.241-11.856.102.06.158.186.179.373-1.492.78-5.098 5.603-8.724 11.784-3.714 6.33-6.193 11.946-6.022 13.48-.22.114-.394.142-.515.07-.939-.55 1.676-6.752 5.84-13.851"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "2-scam_svg__m",
    width: 16,
    height: 26,
    x: 23,
    y: 31,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    d: "M29.92 43.014c3.627-6.184 7.234-11.007 8.725-11.785.17 1.535-2.309 7.15-6.021 13.478-3.628 6.184-7.236 11.007-8.726 11.784-.17-1.535 2.309-7.15 6.021-13.477"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2-scam_svg__n)",
    mask: "url(#2-scam_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.458 37.46c1.058-2.143.33-2.094-.978-1.3l1.64-3.097-1.1.78-1.597 3.014c-.289.205-.59.424-.889.642l1.608-3.034-1.1.78-1.64 3.094q-.364.267-.709.513l.006-.01-1.517 1.074-1.067 2.013s.827-.603.8-.568c.445-.315.355.025.195.378l-1.869 3.526c.03-.021.07-.047.11-.069l-.117.083-2.619 4.94c-.146.255-.432.696-.744.918.003.01-.8.566-.8.566l-1.41 2.405 1.431-1.014c.266-.188.524-.366.78-.546l-1.658 3.13 1.098-.778 1.642-3.098q.444-.304.871-.608l-1.634 3.084 1.1-.78 1.657-3.125c1.945-1.493 3.663-3.208 5.4-6.297 1.4-2.487 1.308-3.09.487-2.778a16.1 16.1 0 0 0 2.623-3.838m-5.087 7.786c-1.24 2.339-3.438 3.73-4.184 4.26l2.199-4.15c.746-.527 3.278-2.55 1.985-.11m2.59-5.49c-1.128 2.128-2.947 3.262-3.569 3.702l1.994-3.762c.621-.44 2.751-2.16 1.575.06"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "2-scam_svg__o",
    width: 38,
    height: 61,
    x: 9,
    y: -3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC47",
    d: "M25.767 57.754c-.202-1.787 2.694-8.342 7.029-15.731 4.235-7.22 6.568-14.133 8.305-15.035C59.833-7.44 20.051-5.862 15.716 1.528 11.48 8.747.464 41.761 25.767 57.753"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#2-scam_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M39.426 11.684c.453.208.898.255 1.302.15.71-.186 1.298-.84 1.596-1.92.594-2.158-.198-5.2-1.77-6.795-.787-.797-1.619-1.081-2.329-.897-.71.185-1.298.84-1.595 1.919-.474 1.72-.067 4 .913 5.663l-2.083 7.463c-1.896-1.548-3.838-2.066-5.528-1.625-1.966.512-3.592 2.32-4.415 5.306-1.649 5.988.564 14.43 4.932 18.86 2.19 2.22 4.508 3.014 6.484 2.499 1.966-.513 3.592-2.32 4.415-5.307l.538-1.956-5.363-.29 2.187 2.218c-.67 1.167-1.576 1.899-2.605 2.167-1.506.392-3.274-.213-4.946-1.909-3.338-3.384-5.02-9.823-3.765-14.378.626-2.273 1.866-3.652 3.366-4.042 1.506-.392 3.274.212 4.946 1.908l.935.948zm1.459-3.229c-.147.534-.438.858-.79.949-.35.091-.762-.05-1.15-.443-.778-.789-1.17-2.293-.876-3.36.147-.535.438-.858.789-.95.351-.09.763.05 1.151.444.778.788 1.17 2.293.876 3.36",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M43.14 2.445c1.573 1.594 2.365 4.637 1.77 6.795l-2.586.674c.594-2.158-.198-5.201-1.77-6.795zM40.812 1.548c.71-.185 1.542.1 2.328.896l-2.587.674c-.786-.797-1.618-1.081-2.328-.896z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.91 9.24c-.297 1.08-.884 1.734-1.595 1.919l-2.586.674c.71-.185 1.298-.84 1.595-1.919zM42.596 4.42c.778.789 1.17 2.293.876 3.36l-2.587.675c.294-1.068-.098-2.572-.876-3.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.445 3.977c.351-.091.763.049 1.151.443l-2.587.674c-.388-.394-.8-.535-1.15-.443zM43.472 7.78c-.148.535-.438.858-.79.95l-2.586.674c.35-.092.642-.415.789-.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40.656 4.926c.147-.534.438-.857.789-.949l-2.587.674c-.351.092-.642.415-.789.949zM42.683 8.73c-.351.091-.763-.05-1.152-.444l-2.587.674c.39.395.8.535 1.152.444zM43.315 11.159c-.404.105-.849.058-1.302-.15l-2.587.674c.453.208.898.255 1.302.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.531 8.287c-.777-.789-1.17-2.293-.875-3.36l-2.587.673c-.294 1.068.098 2.572.875 3.36zM39.217 3.466c.297-1.079.885-1.733 1.595-1.918l-2.587.674c-.71.185-1.298.839-1.595 1.918z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40.13 9.129c-.98-1.662-1.387-3.943-.914-5.663l-2.587.674c-.473 1.72-.066 4 .913 5.663zM39.228 20.992l2.785-9.983-2.587.675-2.785 9.982zM40.13 9.13l-2.083 7.463-2.587.674 2.083-7.464zM43.935 36.326l.538-1.956-2.587.673L41.348 37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m38.294 20.043.934.948-2.586.674-.935-.948zM44.473 34.37l-5.363-.29-2.587.675 5.363.29zM39.52 41.632c1.966-.513 3.592-2.32 4.415-5.306L41.348 37c-.823 2.986-2.45 4.793-4.415 5.306zM38.047 16.593c-1.896-1.55-3.838-2.066-5.528-1.626l-2.586.674c1.69-.44 3.631.077 5.528 1.626z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m39.11 34.08 2.187 2.218-2.587.673-2.187-2.217zM33.347 18.136c1.506-.392 3.274.212 4.947 1.908l-2.587.674c-1.673-1.696-3.441-2.3-4.947-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.296 36.298c-.67 1.166-1.576 1.899-2.604 2.166l-2.586.674c1.028-.268 1.934-1 2.603-2.167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M38.692 38.464c-1.506.392-3.274-.212-4.946-1.908l-2.587.674c1.672 1.696 3.44 2.3 4.946 1.908zM29.982 22.177c.625-2.272 1.864-3.65 3.364-4.041l-2.586.673c-1.5.39-2.74 1.77-3.365 4.042zM33.036 39.133c2.189 2.22 4.507 3.014 6.483 2.5l-2.586.673c-1.976.515-4.294-.278-6.484-2.499zM32.52 14.967c-1.967.513-3.593 2.32-4.416 5.306l-2.587.675c.823-2.987 2.45-4.794 4.415-5.307z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.746 36.556c-3.338-3.385-5.02-9.823-3.765-14.379l-2.586.674c-1.255 4.555.426 10.994 3.764 14.379z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M28.105 20.274c-1.65 5.987.563 14.43 4.931 18.86l-2.587.673c-4.368-4.43-6.58-12.872-4.931-18.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M43.122 2.52c1.572 1.594 2.365 4.637 1.77 6.796-.467 1.695-1.65 2.34-2.898 1.767l-2.785 9.983-.935-.948c-3.338-3.384-7.057-2.421-8.311 2.134-1.255 4.555.426 10.994 3.764 14.378 2.814 2.854 5.9 2.618 7.55-.258l-2.186-2.217 5.363.29-.538 1.955c-1.65 5.988-6.531 7.237-10.9 2.808-4.367-4.43-6.58-12.872-4.93-18.86 1.53-5.553 5.84-7.03 9.943-3.68l2.082-7.465c-.98-1.663-1.386-3.941-.913-5.66.595-2.16 2.351-2.617 3.924-1.023m-.544 1.976c-.778-.788-1.647-.562-1.94.506-.294 1.067.097 2.572.875 3.36.777.788 1.646.562 1.94-.505s-.098-2.572-.876-3.36"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#363636",
    strokeWidth: 0.185,
    d: "M84.14 26.972q.724 1.084.508 2.294a2.79 2.79 0 0 1-1.243 1.893 2.79 2.79 0 0 1-2.226.422q-1.2-.265-1.923-1.35-.725-1.086-.509-2.295a2.79 2.79 0 0 1 1.244-1.893 2.79 2.79 0 0 1 2.226-.421q1.198.264 1.923 1.35Zm13.591-8.576.402 2.051.012.063-.055.033-11.782 7.188-.075.045-1.996-2.99-.002-.02-.142-1.018-.008-.06.05-.031 11.3-7.102.058-.036.05.043 2.157 1.78.025.022z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    stroke: "#363636",
    strokeWidth: 0.185,
    d: "M84.169 25.916q.806 1.026.684 2.248a2.79 2.79 0 0 1-1.092 1.984 2.79 2.79 0 0 1-2.187.593c-.81-.112-1.485-.514-2.022-1.197q-.806-1.025-.685-2.247a2.79 2.79 0 0 1 1.093-1.985 2.79 2.79 0 0 1 2.186-.592q1.216.171 2.023 1.196Zm13.487-7.547-.078.056-11.19 8.08-.07.052-2.263-2.88.067-.056 10.495-8.963.074-.063z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.055 4.258c.713-.665.823-1.114 1.302-2.372L42.105 4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E008F",
    d: "m44.184-7.177 2.031.56-2.982 11.331s-.14.74-.702.866c-.762.172-1.604-.308-1.895-.57l.038-.14s.736.072 1.027-.843c1.975-6.21 2.483-11.204 2.483-11.204"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#230AFF",
    d: "m44.354-5.819 2.031.56-3.063 10.13s-.14.74-.702.866c-1.059.239-1.987-.728-1.987-.728s.866.09 1.157-.825c1.975-6.21 2.564-10.003 2.564-10.003"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m85.415 40.486.065-.216-.028.437zm-1.048-3.808-.045-.22a.225.225 0 0 1 .205.378zM82.57 44.66l-.225.004c-.01-.642.125-1.626.568-2.507.446-.887 1.215-1.684 2.465-1.894l.037.221.037.222c-1.073.18-1.737.856-2.138 1.653-.403.802-.53 1.71-.52 2.298zm2.845-4.175-.065.215c-.64-.193-1.5-.629-1.917-1.338a1.7 1.7 0 0 1-.195-1.285c.11-.483.418-1.002.97-1.558l.159.158.16.158c-.516.52-.765.968-.852 1.343-.084.369-.015.684.145.957.332.563 1.061.954 1.66 1.134zm-1.048-3.808.045.22c-.453.093-1.157.133-1.804-.054-.656-.19-1.275-.623-1.475-1.482l.219-.051.219-.051c.153.656.613.994 1.162 1.153.557.16 1.184.127 1.589.045z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "2-scam_svg__d",
    width: 16.448,
    height: 6.56,
    x: 57.484,
    y: 41.563,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.495,
    dy: -0.727
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.066
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.839216 0 0 0 0 0.643137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_12143_13045"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "2-scam_svg__g",
    width: 28.797,
    height: 22.351,
    x: 26.79,
    y: 56.563,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.576,
    dy: -0.864
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.115
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.839216 0 0 0 0 0.643137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_12143_13045"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "2-scam_svg__h",
    width: 15.623,
    height: 14.063,
    x: 44.912,
    y: 45.342,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.576,
    dy: -0.864
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.115
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.839216 0 0 0 0 0.643137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_12143_13045"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "2-scam_svg__j",
    width: 28.797,
    height: 22.351,
    x: 26.79,
    y: 56.565,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.576,
    dy: -0.864
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.115
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.839216 0 0 0 0 0.643137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_12143_13045"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "2-scam_svg__l",
    width: 20.216,
    height: 31.314,
    x: 22.004,
    y: 28.617,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.944,
    dy: -3.888
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.194
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.838565 0 0 0 0 0.643229 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_12143_13045"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2-scam_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2-scam_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m66.45 41.196 10.085 5.169-11.251 1.354-10.085-5.169z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2-scam_svg__n"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.905 38.807 10.338-9.573-8.355 19.493L22.55 58.3z"
  })))));
};
export default Svg2Scam;